/* tslint:disable */
/* eslint-disable */
/**
 * Growdash Identity
 * Growdash Identity
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessDto
 */
export interface AccessDto {
    /**
     * JWT auth token
     * @type {AuthToken}
     * @memberof AccessDto
     */
    'access_token': AuthToken;
    /**
     * JWT auth token
     * @type {AuthToken}
     * @memberof AccessDto
     */
    'accessToken': AuthToken;
    /**
     * JWT refresh token
     * @type {string}
     * @memberof AccessDto
     */
    'refresh_token': string;
    /**
     * JWT refresh token
     * @type {string}
     * @memberof AccessDto
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface AccountInformation
 */
export interface AccountInformation {
    /**
     * 
     * @type {string}
     * @memberof AccountInformation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AccountInformation
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AccountInformation
     */
    'company': string;
    /**
     * 
     * @type {object}
     * @memberof AccountInformation
     */
    'phoneNumber': object;
    /**
     * 
     * @type {object}
     * @memberof AccountInformation
     */
    'defaultBrand': object;
}
/**
 * 
 * @export
 * @interface AuthToken
 */
export interface AuthToken {
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    'username': string;
    /**
     * 
     * @type {number}
     * @memberof AuthToken
     */
    'sub': number;
    /**
     * 
     * @type {number}
     * @memberof AuthToken
     */
    'clientId': number;
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AuthToken
     */
    'countryId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthToken
     */
    'roles': Array<AuthTokenRolesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthToken
     */
    'features': Array<AuthTokenFeaturesEnum>;
    /**
     * 
     * @type {object}
     * @memberof AuthToken
     */
    'plan': object | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthToken
     */
    'featuresNew': Array<AuthTokenFeaturesNewEnum>;
    /**
     * 
     * @type {number}
     * @memberof AuthToken
     */
    'groupId': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthToken
     */
    'products': Array<string>;
}

export const AuthTokenRolesEnum = {
    User: 'user',
    Manager: 'manager'
} as const;

export type AuthTokenRolesEnum = typeof AuthTokenRolesEnum[keyof typeof AuthTokenRolesEnum];
export const AuthTokenFeaturesEnum = {
    Growintel: 'growintel'
} as const;

export type AuthTokenFeaturesEnum = typeof AuthTokenFeaturesEnum[keyof typeof AuthTokenFeaturesEnum];
export const AuthTokenFeaturesNewEnum = {
    TrendsAishaInsight: 'trends.aishaInsight',
    TrendsAvgPrice: 'trends.avgPrice',
    TrendsNewRestaurants: 'trends.newRestaurants',
    TrendsClosedRestaurants: 'trends.closedRestaurants',
    TrendsCuisineBenchmark: 'trends.cuisineBenchmark',
    CompareAishaInsight: 'compare.aishaInsight',
    CompareHexaMap: 'compare.hexaMap',
    CompareHeatMap: 'compare.heatMap',
    CompareCompareUniqueMenuItems: 'compare.compareUniqueMenuItems',
    WatchlistAishaInsight: 'watchlist.aishaInsight',
    WatchlistHeatMap: 'watchlist.heatMap',
    WatchlistManageWatchlist: 'watchlist.manageWatchlist',
    CuisineAishaInsight: 'cuisine.aishaInsight',
    CuisineHeatMap: 'cuisine.heatMap',
    CuisineOperationBenchmark: 'cuisine.operationBenchmark',
    SearchBrands: 'search.brands',
    SearchBranches: 'search.branches',
    SearchItems: 'search.items',
    GrowintelPro: 'growintel.pro'
} as const;

export type AuthTokenFeaturesNewEnum = typeof AuthTokenFeaturesNewEnum[keyof typeof AuthTokenFeaturesNewEnum];

/**
 * 
 * @export
 * @interface BasicClientDto
 */
export interface BasicClientDto {
    /**
     * Id of the client
     * @type {number}
     * @memberof BasicClientDto
     */
    'id': number;
    /**
     * Name of the client
     * @type {string}
     * @memberof BasicClientDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface BasicCountryDto
 */
export interface BasicCountryDto {
    /**
     * Country id
     * @type {number}
     * @memberof BasicCountryDto
     */
    'id': number;
    /**
     * Country name
     * @type {string}
     * @memberof BasicCountryDto
     */
    'name': string;
    /**
     * Country timezone
     * @type {string}
     * @memberof BasicCountryDto
     */
    'timezone': string;
    /**
     * Country currency
     * @type {string}
     * @memberof BasicCountryDto
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface BillingAddressInformation
 */
export interface BillingAddressInformation {
    /**
     * 
     * @type {number}
     * @memberof BillingAddressInformation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressInformation
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressInformation
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressInformation
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface BillingInformationDto
 */
export interface BillingInformationDto {
    /**
     * The id of the billing information
     * @type {number}
     * @memberof BillingInformationDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BillingInformationDto
     */
    'companyName': string;
    /**
     * The address of the company
     * @type {string}
     * @memberof BillingInformationDto
     */
    'address': string;
    /**
     * The city of the company
     * @type {string}
     * @memberof BillingInformationDto
     */
    'city': string;
    /**
     * The state of the company
     * @type {string}
     * @memberof BillingInformationDto
     */
    'state': string;
    /**
     * The tax number of the company
     * @type {string}
     * @memberof BillingInformationDto
     */
    'taxNumber': string;
    /**
     * The trade licence number of the company
     * @type {string}
     * @memberof BillingInformationDto
     */
    'tradeLicenceNumber': string;
    /**
     * The date the billing information was created
     * @type {string}
     * @memberof BillingInformationDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface ChangeBillingInformationAddressDto
 */
export interface ChangeBillingInformationAddressDto {
    /**
     * The address of the company
     * @type {string}
     * @memberof ChangeBillingInformationAddressDto
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
    /**
     * The current password
     * @type {string}
     * @memberof ChangePasswordDto
     */
    'oldPassword': string;
    /**
     * The new password
     * @type {string}
     * @memberof ChangePasswordDto
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ChangeTokenDto
 */
export interface ChangeTokenDto {
    /**
     * newClientId
     * @type {number}
     * @memberof ChangeTokenDto
     */
    'newClientId': number;
}
/**
 * 
 * @export
 * @interface ClientDto
 */
export interface ClientDto {
    /**
     * Id of the client
     * @type {number}
     * @memberof ClientDto
     */
    'id': number;
    /**
     * Name of the client
     * @type {string}
     * @memberof ClientDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateCreditCardDto
 */
export interface CreateCreditCardDto {
    /**
     * The payment method ID that was created using the SDK
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'cardToken': string;
    /**
     * Which payment provider to use
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'paymentProvider': CreateCreditCardDtoPaymentProviderEnum;
    /**
     * Whether the card is the default card
     * @type {boolean}
     * @memberof CreateCreditCardDto
     */
    'isDefault'?: boolean;
    /**
     * The address of the cardholder
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'address': string;
    /**
     * The city of the cardholder
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'city': string;
    /**
     * The state of the cardholder
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'state': string;
    /**
     * The alias of the credit card
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'alias'?: string;
    /**
     * The network of the credit card
     * @type {string}
     * @memberof CreateCreditCardDto
     */
    'network'?: CreateCreditCardDtoNetworkEnum;
}

export const CreateCreditCardDtoPaymentProviderEnum = {
    Stripe: 'stripe',
    Adyen: 'adyen',
    BankTransfer: 'bank-transfer'
} as const;

export type CreateCreditCardDtoPaymentProviderEnum = typeof CreateCreditCardDtoPaymentProviderEnum[keyof typeof CreateCreditCardDtoPaymentProviderEnum];
export const CreateCreditCardDtoNetworkEnum = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    AmericanExpress: 'american_express',
    Amex: 'amex',
    Maestro: 'maestro',
    Pix: 'pix',
    Hipercard: 'hipercard'
} as const;

export type CreateCreditCardDtoNetworkEnum = typeof CreateCreditCardDtoNetworkEnum[keyof typeof CreateCreditCardDtoNetworkEnum];

/**
 * 
 * @export
 * @interface CreateSubscriptionDto
 */
export interface CreateSubscriptionDto {
    /**
     * The ID of the plan to subscribe to
     * @type {number}
     * @memberof CreateSubscriptionDto
     */
    'planId': number;
    /**
     * The billing cadence of the plan
     * @type {string}
     * @memberof CreateSubscriptionDto
     */
    'billingCadence': string;
    /**
     * The ID of the payment method to use for the subscription
     * @type {string}
     * @memberof CreateSubscriptionDto
     */
    'paymentMethodId': string;
}
/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CreditCardDto
 */
export interface CreditCardDto {
    /**
     * The ID of the credit card
     * @type {number}
     * @memberof CreditCardDto
     */
    'id': number;
    /**
     * The payment method ID that was created using the SDK
     * @type {string}
     * @memberof CreditCardDto
     */
    'cardToken': string;
    /**
     * The name of the cardholder
     * @type {string}
     * @memberof CreditCardDto
     */
    'userName': string;
    /**
     * The last four digits of the card number
     * @type {string}
     * @memberof CreditCardDto
     */
    'lastFourDigits': string;
    /**
     * The payment provider
     * @type {string}
     * @memberof CreditCardDto
     */
    'paymentProvider': string;
    /**
     * Whether the card is the default card
     * @type {boolean}
     * @memberof CreditCardDto
     */
    'isDefault': boolean;
    /**
     * The date the credit card was created
     * @type {string}
     * @memberof CreditCardDto
     */
    'createdAt': string;
    /**
     * The alias of the credit card
     * @type {string}
     * @memberof CreditCardDto
     */
    'alias'?: string;
    /**
     * The network of the credit card
     * @type {string}
     * @memberof CreditCardDto
     */
    'network'?: CreditCardDtoNetworkEnum;
}

export const CreditCardDtoNetworkEnum = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    AmericanExpress: 'american_express',
    Amex: 'amex',
    Maestro: 'maestro',
    Pix: 'pix',
    Hipercard: 'hipercard'
} as const;

export type CreditCardDtoNetworkEnum = typeof CreditCardDtoNetworkEnum[keyof typeof CreditCardDtoNetworkEnum];

/**
 * 
 * @export
 * @interface ForgotPasswordDto
 */
export interface ForgotPasswordDto {
    /**
     * The email for resetting password
     * @type {string}
     * @memberof ForgotPasswordDto
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface HealthControllerCheck200Response
 */
export interface HealthControllerCheck200Response {
    /**
     * 
     * @type {string}
     * @memberof HealthControllerCheck200Response
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: HealthControllerCheck200ResponseInfoValue; }}
     * @memberof HealthControllerCheck200Response
     */
    'info'?: { [key: string]: HealthControllerCheck200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerCheck200ResponseInfoValue; }}
     * @memberof HealthControllerCheck200Response
     */
    'error'?: { [key: string]: HealthControllerCheck200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerCheck200ResponseInfoValue; }}
     * @memberof HealthControllerCheck200Response
     */
    'details'?: { [key: string]: HealthControllerCheck200ResponseInfoValue; };
}
/**
 * 
 * @export
 * @interface HealthControllerCheck200ResponseInfoValue
 */
export interface HealthControllerCheck200ResponseInfoValue {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof HealthControllerCheck200ResponseInfoValue
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface HealthControllerCheck503Response
 */
export interface HealthControllerCheck503Response {
    /**
     * 
     * @type {string}
     * @memberof HealthControllerCheck503Response
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: HealthControllerCheck200ResponseInfoValue; }}
     * @memberof HealthControllerCheck503Response
     */
    'info'?: { [key: string]: HealthControllerCheck200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerCheck200ResponseInfoValue; }}
     * @memberof HealthControllerCheck503Response
     */
    'error'?: { [key: string]: HealthControllerCheck200ResponseInfoValue; } | null;
    /**
     * 
     * @type {{ [key: string]: HealthControllerCheck200ResponseInfoValue; }}
     * @memberof HealthControllerCheck503Response
     */
    'details'?: { [key: string]: HealthControllerCheck200ResponseInfoValue; };
}
/**
 * 
 * @export
 * @interface InvoiceArrayItem
 */
export interface InvoiceArrayItem {
    /**
     * 
     * @type {string}
     * @memberof InvoiceArrayItem
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceArrayItem
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceArrayItem
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * The invoice number
     * @type {string}
     * @memberof InvoiceDto
     */
    'invoiceNumber': string;
    /**
     * The type of invoice
     * @type {string}
     * @memberof InvoiceDto
     */
    'type': InvoiceDtoTypeEnum;
    /**
     * The date of the invoice
     * @type {string}
     * @memberof InvoiceDto
     */
    'date': string;
}

export const InvoiceDtoTypeEnum = {
    Paid: 'paid',
    Uncollectible: 'uncollectible',
    Refund: 'refund'
} as const;

export type InvoiceDtoTypeEnum = typeof InvoiceDtoTypeEnum[keyof typeof InvoiceDtoTypeEnum];

/**
 * 
 * @export
 * @interface PaginatedResponseDto
 */
export interface PaginatedResponseDto {
    /**
     * Array of result data
     * @type {Array<object>}
     * @memberof PaginatedResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {object}
     * @memberof PaginatedResponseDto
     */
    'metadata'?: object;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginatedResponseDto
     */
    'page': number;
    /**
     * Rows per page (limit)
     * @type {number}
     * @memberof PaginatedResponseDto
     */
    'take': number;
    /**
     * Total number of rows.
     * @type {number}
     * @memberof PaginatedResponseDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaymentDetailsDto
 */
export interface PaymentDetailsDto {
    /**
     * Email address
     * @type {string}
     * @memberof PaymentDetailsDto
     */
    'email': string;
    /**
     * Payment method ID created using stripe API on the frontend
     * @type {string}
     * @memberof PaymentDetailsDto
     */
    'paymentMethodId': string;
    /**
     * Should this payment method be set as the default?
     * @type {boolean}
     * @memberof PaymentDetailsDto
     */
    'isDefault': boolean;
    /**
     * Country ID
     * @type {number}
     * @memberof PaymentDetailsDto
     */
    'countryId': number;
    /**
     * City name
     * @type {string}
     * @memberof PaymentDetailsDto
     */
    'city': string;
    /**
     * State
     * @type {string}
     * @memberof PaymentDetailsDto
     */
    'state': string;
    /**
     * How frequently should the customer be billed
     * @type {string}
     * @memberof PaymentDetailsDto
     */
    'billingCadence': PaymentDetailsDtoBillingCadenceEnum;
    /**
     * Address
     * @type {string}
     * @memberof PaymentDetailsDto
     */
    'address': string;
    /**
     * Plan ID
     * @type {number}
     * @memberof PaymentDetailsDto
     */
    'planId': number;
}

export const PaymentDetailsDtoBillingCadenceEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;

export type PaymentDetailsDtoBillingCadenceEnum = typeof PaymentDetailsDtoBillingCadenceEnum[keyof typeof PaymentDetailsDtoBillingCadenceEnum];

/**
 * 
 * @export
 * @interface PaymentInformation
 */
export interface PaymentInformation {
    /**
     * 
     * @type {string}
     * @memberof PaymentInformation
     */
    'billingType': PaymentInformationBillingTypeEnum | null;
    /**
     * 
     * @type {object}
     * @memberof PaymentInformation
     */
    'paymentAmount': object | null;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof PaymentInformation
     */
    'paymentMethod': PaymentMethod | null;
}

export const PaymentInformationBillingTypeEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;

export type PaymentInformationBillingTypeEnum = typeof PaymentInformationBillingTypeEnum[keyof typeof PaymentInformationBillingTypeEnum];

/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'card': string;
}
/**
 * 
 * @export
 * @interface PlanDto
 */
export interface PlanDto {
    /**
     * 
     * @type {number}
     * @memberof PlanDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PlanDto
     */
    'countryId': number;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof PlanDto
     */
    'monthlyPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PlanDto
     */
    'yearlyPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof PlanDto
     */
    'isFeatured': boolean;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof PlanDto
     */
    'level': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlanDto
     */
    'features': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlanDto
     */
    'featureSet'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PlanDto
     */
    'targetAudience'?: string;
}
/**
 * 
 * @export
 * @interface PlanInformation
 */
export interface PlanInformation {
    /**
     * 
     * @type {string}
     * @memberof PlanInformation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlanInformation
     */
    'status': PlanInformationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PlanInformation
     */
    'region': PlanInformationRegionEnum;
    /**
     * 
     * @type {string}
     * @memberof PlanInformation
     */
    'paymentStatus': string;
    /**
     * 
     * @type {string}
     * @memberof PlanInformation
     */
    'nextBillingDate': string;
    /**
     * 
     * @type {number}
     * @memberof PlanInformation
     */
    'nextPaymentAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PlanInformation
     */
    'currency': string;
}

export const PlanInformationStatusEnum = {
    Active: 'active',
    Scheduled: 'scheduled',
    Inactive: 'inactive',
    Cancelled: 'cancelled'
} as const;

export type PlanInformationStatusEnum = typeof PlanInformationStatusEnum[keyof typeof PlanInformationStatusEnum];
export const PlanInformationRegionEnum = {
    UnitedArabEmirates: 'United Arab Emirates',
    Ksa: 'KSA',
    UnitedKingdom: 'United Kingdom',
    Qatar: 'Qatar',
    Kuwait: 'Kuwait',
    Jordan: 'Jordan',
    Romania: 'Romania'
} as const;

export type PlanInformationRegionEnum = typeof PlanInformationRegionEnum[keyof typeof PlanInformationRegionEnum];

/**
 * 
 * @export
 * @interface ProfileAccountSubscriptionResponse
 */
export interface ProfileAccountSubscriptionResponse {
    /**
     * 
     * @type {AccountInformation}
     * @memberof ProfileAccountSubscriptionResponse
     */
    'account': AccountInformation;
    /**
     * 
     * @type {PlanInformation}
     * @memberof ProfileAccountSubscriptionResponse
     */
    'plan': PlanInformation | null;
    /**
     * 
     * @type {BillingAddressInformation}
     * @memberof ProfileAccountSubscriptionResponse
     */
    'billing': BillingAddressInformation | null;
    /**
     * 
     * @type {PaymentInformation}
     * @memberof ProfileAccountSubscriptionResponse
     */
    'payment': PaymentInformation | null;
    /**
     * 
     * @type {Array<InvoiceArrayItem>}
     * @memberof ProfileAccountSubscriptionResponse
     */
    'invoices': Array<InvoiceArrayItem>;
}
/**
 * 
 * @export
 * @interface ReceiptDto
 */
export interface ReceiptDto {
    /**
     * The invoice number
     * @type {string}
     * @memberof ReceiptDto
     */
    'invoiceNumber': string;
    /**
     * The type of billing cadence
     * @type {string}
     * @memberof ReceiptDto
     */
    'paymentType': ReceiptDtoPaymentTypeEnum;
    /**
     * The payment provider
     * @type {string}
     * @memberof ReceiptDto
     */
    'paymentProvider': ReceiptDtoPaymentProviderEnum;
    /**
     * The price of the receipt
     * @type {number}
     * @memberof ReceiptDto
     */
    'price': number;
    /**
     * The type of transaction
     * @type {string}
     * @memberof ReceiptDto
     */
    'transactionType': string;
    /**
     * Invoice type
     * @type {string}
     * @memberof ReceiptDto
     */
    'invoiceType': string;
    /**
     * The invoice id
     * @type {number}
     * @memberof ReceiptDto
     */
    'invoiceId': number;
    /**
     * The billing info
     * @type {object}
     * @memberof ReceiptDto
     */
    'billingInfo': object;
    /**
     * The date of the receipt
     * @type {string}
     * @memberof ReceiptDto
     */
    'date': string;
}

export const ReceiptDtoPaymentTypeEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;

export type ReceiptDtoPaymentTypeEnum = typeof ReceiptDtoPaymentTypeEnum[keyof typeof ReceiptDtoPaymentTypeEnum];
export const ReceiptDtoPaymentProviderEnum = {
    Stripe: 'stripe',
    Adyen: 'adyen',
    BankTransfer: 'bank-transfer'
} as const;

export type ReceiptDtoPaymentProviderEnum = typeof ReceiptDtoPaymentProviderEnum[keyof typeof ReceiptDtoPaymentProviderEnum];

/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * The password for login
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface SignInDto
 */
export interface SignInDto {
    /**
     * The username for login
     * @type {string}
     * @memberof SignInDto
     */
    'username': string;
    /**
     * The password for login
     * @type {string}
     * @memberof SignInDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface SignUpDto
 */
export interface SignUpDto {
    /**
     * The first name of the user
     * @type {string}
     * @memberof SignUpDto
     */
    'firstName': string;
    /**
     * The last name of the user
     * @type {string}
     * @memberof SignUpDto
     */
    'lastName': string;
    /**
     * The email user is signing up with
     * @type {string}
     * @memberof SignUpDto
     */
    'email': string;
    /**
     * Password
     * @type {string}
     * @memberof SignUpDto
     */
    'password': string;
    /**
     * Country
     * @type {number}
     * @memberof SignUpDto
     */
    'countryId': number;
    /**
     * The industry of the user
     * @type {string}
     * @memberof SignUpDto
     */
    'industry': SignUpDtoIndustryEnum;
    /**
     * Company Name
     * @type {string}
     * @memberof SignUpDto
     */
    'companyName'?: string;
    /**
     * Company Legal Name
     * @type {string}
     * @memberof SignUpDto
     */
    'companyLegalName'?: string;
    /**
     * OTP
     * @type {string}
     * @memberof SignUpDto
     */
    'otp': string;
}

export const SignUpDtoIndustryEnum = {
    Restaurants: 'Restaurants',
    FoodDeliveryAggregators: 'Food Delivery Aggregators',
    Fmcg: 'FMCG',
    RestaurantSupplier: 'Restaurant Supplier',
    ConsultantResearcher: 'Consultant / Researcher',
    Others: 'Others'
} as const;

export type SignUpDtoIndustryEnum = typeof SignUpDtoIndustryEnum[keyof typeof SignUpDtoIndustryEnum];

/**
 * 
 * @export
 * @interface UpdateSubscriptionDto
 */
export interface UpdateSubscriptionDto {
    /**
     * The ID of the plan to subscribe to
     * @type {number}
     * @memberof UpdateSubscriptionDto
     */
    'planId': number;
    /**
     * The billing cadence of the plan
     * @type {string}
     * @memberof UpdateSubscriptionDto
     */
    'billingCadence': string;
    /**
     * The ID of the payment method to use for the subscription
     * @type {string}
     * @memberof UpdateSubscriptionDto
     */
    'paymentMethodId': string;
}
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    'preferredBrand': string;
}
/**
 * 
 * @export
 * @interface UserCountByStatusDto
 */
export interface UserCountByStatusDto {
    /**
     * Count of active users
     * @type {number}
     * @memberof UserCountByStatusDto
     */
    'active': number;
    /**
     * Count of pending users
     * @type {number}
     * @memberof UserCountByStatusDto
     */
    'pending': number;
    /**
     * Count of expired users
     * @type {number}
     * @memberof UserCountByStatusDto
     */
    'expired': number;
    /**
     * Count of total users
     * @type {number}
     * @memberof UserCountByStatusDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * id
     * @type {number}
     * @memberof UserDto
     */
    'id': number;
    /**
     * Full name
     * @type {string}
     * @memberof UserDto
     */
    'fullName': string;
    /**
     * Email
     * @type {string}
     * @memberof UserDto
     */
    'email': string;
    /**
     * Status
     * @type {string}
     * @memberof UserDto
     */
    'status': UserDtoStatusEnum;
    /**
     * Invited At
     * @type {string}
     * @memberof UserDto
     */
    'invitedAt': string;
    /**
     * Email notifications subscription status
     * @type {boolean}
     * @memberof UserDto
     */
    'emailNotificationsEnabled': boolean;
}

export const UserDtoStatusEnum = {
    Verified: 'verified',
    Pending: 'pending',
    Expired: 'expired'
} as const;

export type UserDtoStatusEnum = typeof UserDtoStatusEnum[keyof typeof UserDtoStatusEnum];

/**
 * 
 * @export
 * @interface UserInfoDto
 */
export interface UserInfoDto {
    /**
     * 
     * @type {string}
     * @memberof UserInfoDto
     */
    'username': string;
    /**
     * 
     * @type {number}
     * @memberof UserInfoDto
     */
    'sub': number;
    /**
     * 
     * @type {number}
     * @memberof UserInfoDto
     */
    'clientId': number;
    /**
     * 
     * @type {string}
     * @memberof UserInfoDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UserInfoDto
     */
    'countryId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfoDto
     */
    'roles': Array<UserInfoDtoRolesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfoDto
     */
    'features': Array<UserInfoDtoFeaturesEnum>;
    /**
     * 
     * @type {object}
     * @memberof UserInfoDto
     */
    'plan': object | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfoDto
     */
    'featuresNew': Array<UserInfoDtoFeaturesNewEnum>;
    /**
     * 
     * @type {number}
     * @memberof UserInfoDto
     */
    'groupId': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfoDto
     */
    'products': Array<string>;
    /**
     * Country info
     * @type {BasicCountryDto}
     * @memberof UserInfoDto
     */
    'country': BasicCountryDto;
    /**
     * Client info
     * @type {BasicClientDto}
     * @memberof UserInfoDto
     */
    'client': BasicClientDto;
    /**
     * Permission/module names
     * @type {Array<string>}
     * @memberof UserInfoDto
     */
    'permissions': Array<string>;
}

export const UserInfoDtoRolesEnum = {
    User: 'user',
    Manager: 'manager'
} as const;

export type UserInfoDtoRolesEnum = typeof UserInfoDtoRolesEnum[keyof typeof UserInfoDtoRolesEnum];
export const UserInfoDtoFeaturesEnum = {
    Growintel: 'growintel'
} as const;

export type UserInfoDtoFeaturesEnum = typeof UserInfoDtoFeaturesEnum[keyof typeof UserInfoDtoFeaturesEnum];
export const UserInfoDtoFeaturesNewEnum = {
    TrendsAishaInsight: 'trends.aishaInsight',
    TrendsAvgPrice: 'trends.avgPrice',
    TrendsNewRestaurants: 'trends.newRestaurants',
    TrendsClosedRestaurants: 'trends.closedRestaurants',
    TrendsCuisineBenchmark: 'trends.cuisineBenchmark',
    CompareAishaInsight: 'compare.aishaInsight',
    CompareHexaMap: 'compare.hexaMap',
    CompareHeatMap: 'compare.heatMap',
    CompareCompareUniqueMenuItems: 'compare.compareUniqueMenuItems',
    WatchlistAishaInsight: 'watchlist.aishaInsight',
    WatchlistHeatMap: 'watchlist.heatMap',
    WatchlistManageWatchlist: 'watchlist.manageWatchlist',
    CuisineAishaInsight: 'cuisine.aishaInsight',
    CuisineHeatMap: 'cuisine.heatMap',
    CuisineOperationBenchmark: 'cuisine.operationBenchmark',
    SearchBrands: 'search.brands',
    SearchBranches: 'search.branches',
    SearchItems: 'search.items',
    GrowintelPro: 'growintel.pro'
} as const;

export type UserInfoDtoFeaturesNewEnum = typeof UserInfoDtoFeaturesNewEnum[keyof typeof UserInfoDtoFeaturesNewEnum];

/**
 * 
 * @export
 * @interface UsersControllerGetUsersByClientId200Response
 */
export interface UsersControllerGetUsersByClientId200Response {
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UsersControllerGetUsersByClientId200Response
     */
    'data'?: Array<UserDto>;
    /**
     * 
     * @type {number}
     * @memberof UsersControllerGetUsersByClientId200Response
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsersControllerGetUsersByClientId200Response
     */
    'take'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsersControllerGetUsersByClientId200Response
     */
    'total'?: number;
    /**
     * 
     * @type {object}
     * @memberof UsersControllerGetUsersByClientId200Response
     */
    'metadata'?: object;
}
/**
 * 
 * @export
 * @interface VerifyEmailDto
 */
export interface VerifyEmailDto {
    /**
     * The email user is signing up with
     * @type {string}
     * @memberof VerifyEmailDto
     */
    'email': string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerChangePassword: async (changePasswordDto: ChangePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('authControllerChangePassword', 'changePasswordDto', changePasswordDto)
            const localVarPath = `/v1/auth/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordDto} forgotPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword: async (forgotPasswordDto: ForgotPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordDto' is not null or undefined
            assertParamExists('authControllerForgotPassword', 'forgotPasswordDto', forgotPasswordDto)
            const localVarPath = `/v1/auth/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefreshToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeTokenDto} changeTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegenerateToken: async (changeTokenDto: ChangeTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeTokenDto' is not null or undefined
            assertParamExists('authControllerRegenerateToken', 'changeTokenDto', changeTokenDto)
            const localVarPath = `/v1/auth/change-token-for-client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword: async (token: string, resetPasswordDto: ResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authControllerResetPassword', 'token', token)
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('authControllerResetPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/v1/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignInDto} signInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn: async (signInDto: SignInDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signInDto' is not null or undefined
            assertParamExists('authControllerSignIn', 'signInDto', signInDto)
            const localVarPath = `/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signInDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignUpDto} signUpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp: async (signUpDto: SignUpDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpDto' is not null or undefined
            assertParamExists('authControllerSignUp', 'signUpDto', signUpDto)
            const localVarPath = `/v1/auth/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyEmailDto} verifyEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyEmail: async (verifyEmailDto: VerifyEmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailDto' is not null or undefined
            assertParamExists('authControllerVerifyEmail', 'verifyEmailDto', verifyEmailDto)
            const localVarPath = `/v1/auth/verify-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/auth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerChangePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerChangePassword(changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerChangePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ForgotPasswordDto} forgotPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerForgotPassword(forgotPasswordDto: ForgotPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerForgotPassword(forgotPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerForgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRefreshToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRefreshToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerRefreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangeTokenDto} changeTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRegenerateToken(changeTokenDto: ChangeTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRegenerateToken(changeTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerRegenerateToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerResetPassword(token: string, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerResetPassword(token, resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignInDto} signInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignIn(signInDto: SignInDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignIn(signInDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignUpDto} signUpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignUp(signUpDto: SignUpDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignUp(signUpDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyEmailDto} verifyEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyEmail(verifyEmailDto: VerifyEmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyEmail(verifyEmailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerVerifyEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerVerifyToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerChangePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerChangePassword(changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotPasswordDto} forgotPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword(forgotPasswordDto: ForgotPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.authControllerForgotPassword(forgotPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefreshToken(options?: RawAxiosRequestConfig): AxiosPromise<AccessDto> {
            return localVarFp.authControllerRefreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangeTokenDto} changeTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegenerateToken(changeTokenDto: ChangeTokenDto, options?: RawAxiosRequestConfig): AxiosPromise<AccessDto> {
            return localVarFp.authControllerRegenerateToken(changeTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword(token: string, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<AccessDto> {
            return localVarFp.authControllerResetPassword(token, resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignInDto} signInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn(signInDto: SignInDto, options?: RawAxiosRequestConfig): AxiosPromise<AccessDto> {
            return localVarFp.authControllerSignIn(signInDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignUpDto} signUpDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp(signUpDto: SignUpDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerSignUp(signUpDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyEmailDto} verifyEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyEmail(verifyEmailDto: VerifyEmailDto, options?: RawAxiosRequestConfig): AxiosPromise<AccessDto> {
            return localVarFp.authControllerVerifyEmail(verifyEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyToken(options?: RawAxiosRequestConfig): AxiosPromise<AuthToken> {
            return localVarFp.authControllerVerifyToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {ChangePasswordDto} changePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerChangePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerChangePassword(changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotPasswordDto} forgotPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerForgotPassword(forgotPasswordDto: ForgotPasswordDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerForgotPassword(forgotPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRefreshToken(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRefreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangeTokenDto} changeTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRegenerateToken(changeTokenDto: ChangeTokenDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRegenerateToken(changeTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerResetPassword(token: string, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerResetPassword(token, resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignInDto} signInDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSignIn(signInDto: SignInDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSignIn(signInDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignUpDto} signUpDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSignUp(signUpDto: SignUpDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSignUp(signUpDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyEmailDto} verifyEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerVerifyEmail(verifyEmailDto: VerifyEmailDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerVerifyEmail(verifyEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerVerifyToken(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerVerifyToken(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthControllerCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthControllerCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck(options?: RawAxiosRequestConfig): AxiosPromise<HealthControllerCheck200Response> {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthControllerCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsControllerIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsControllerIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsControllerIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.metricsControllerIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsControllerIndex(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.metricsControllerIndex(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public metricsControllerIndex(options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).metricsControllerIndex(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change billing information address
         * @param {number} id 
         * @param {ChangeBillingInformationAddressDto} changeBillingInformationAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerChangeBillingInformationAddress: async (id: number, changeBillingInformationAddressDto: ChangeBillingInformationAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsControllerChangeBillingInformationAddress', 'id', id)
            // verify required parameter 'changeBillingInformationAddressDto' is not null or undefined
            assertParamExists('paymentsControllerChangeBillingInformationAddress', 'changeBillingInformationAddressDto', changeBillingInformationAddressDto)
            const localVarPath = `/payments/billing-information/address/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeBillingInformationAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new card
         * @param {CreateCreditCardDto} createCreditCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerCreateCreditCard: async (createCreditCardDto: CreateCreditCardDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCreditCardDto' is not null or undefined
            assertParamExists('paymentsControllerCreateCreditCard', 'createCreditCardDto', createCreditCardDto)
            const localVarPath = `/payments/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCreditCardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a card by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerDeleteCreditCard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsControllerDeleteCreditCard', 'id', id)
            const localVarPath = `/payments/cards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches billing information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetBillingInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/billing-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get credit  cards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetCreditCards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetInvoices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetches receipts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetReceipts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/payments/receipts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle a payment transaction
         * @param {PaymentDetailsDto} paymentDetailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerHandlePayment: async (paymentDetailsDto: PaymentDetailsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentDetailsDto' is not null or undefined
            assertParamExists('paymentsControllerHandlePayment', 'paymentDetailsDto', paymentDetailsDto)
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentDetailsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerHandleStripeWebhook: async (stripeSignature: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('paymentsControllerHandleStripeWebhook', 'stripeSignature', stripeSignature)
            const localVarPath = `/payments/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (stripeSignature != null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a given card as default by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerToggleDefaultCreditCard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('paymentsControllerToggleDefaultCreditCard', 'id', id)
            const localVarPath = `/payments/cards/{id}/default`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change billing information address
         * @param {number} id 
         * @param {ChangeBillingInformationAddressDto} changeBillingInformationAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerChangeBillingInformationAddress(id: number, changeBillingInformationAddressDto: ChangeBillingInformationAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingInformationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerChangeBillingInformationAddress(id, changeBillingInformationAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerChangeBillingInformationAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new card
         * @param {CreateCreditCardDto} createCreditCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerCreateCreditCard(createCreditCardDto: CreateCreditCardDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerCreateCreditCard(createCreditCardDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerCreateCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a card by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerDeleteCreditCard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerDeleteCreditCard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerDeleteCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetches billing information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerGetBillingInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingInformationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerGetBillingInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerGetBillingInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get credit  cards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerGetCreditCards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreditCardDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerGetCreditCards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerGetCreditCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetches invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerGetInvoices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvoiceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerGetInvoices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerGetInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetches receipts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerGetReceipts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReceiptDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerGetReceipts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerGetReceipts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle a payment transaction
         * @param {PaymentDetailsDto} paymentDetailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerHandlePayment(paymentDetailsDto: PaymentDetailsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerHandlePayment(paymentDetailsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerHandlePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerHandleStripeWebhook(stripeSignature: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerHandleStripeWebhook(stripeSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerHandleStripeWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a given card as default by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerToggleDefaultCreditCard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerToggleDefaultCreditCard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.paymentsControllerToggleDefaultCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Change billing information address
         * @param {number} id 
         * @param {ChangeBillingInformationAddressDto} changeBillingInformationAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerChangeBillingInformationAddress(id: number, changeBillingInformationAddressDto: ChangeBillingInformationAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<BillingInformationDto> {
            return localVarFp.paymentsControllerChangeBillingInformationAddress(id, changeBillingInformationAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new card
         * @param {CreateCreditCardDto} createCreditCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerCreateCreditCard(createCreditCardDto: CreateCreditCardDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsControllerCreateCreditCard(createCreditCardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a card by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerDeleteCreditCard(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsControllerDeleteCreditCard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetches billing information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetBillingInformation(options?: RawAxiosRequestConfig): AxiosPromise<BillingInformationDto> {
            return localVarFp.paymentsControllerGetBillingInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get credit  cards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetCreditCards(options?: RawAxiosRequestConfig): AxiosPromise<Array<CreditCardDto>> {
            return localVarFp.paymentsControllerGetCreditCards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetches invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetInvoices(options?: RawAxiosRequestConfig): AxiosPromise<Array<InvoiceDto>> {
            return localVarFp.paymentsControllerGetInvoices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetches receipts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetReceipts(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReceiptDto>> {
            return localVarFp.paymentsControllerGetReceipts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle a payment transaction
         * @param {PaymentDetailsDto} paymentDetailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerHandlePayment(paymentDetailsDto: PaymentDetailsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsControllerHandlePayment(paymentDetailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerHandleStripeWebhook(stripeSignature: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsControllerHandleStripeWebhook(stripeSignature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a given card as default by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerToggleDefaultCreditCard(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.paymentsControllerToggleDefaultCreditCard(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Change billing information address
     * @param {number} id 
     * @param {ChangeBillingInformationAddressDto} changeBillingInformationAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerChangeBillingInformationAddress(id: number, changeBillingInformationAddressDto: ChangeBillingInformationAddressDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerChangeBillingInformationAddress(id, changeBillingInformationAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new card
     * @param {CreateCreditCardDto} createCreditCardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerCreateCreditCard(createCreditCardDto: CreateCreditCardDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerCreateCreditCard(createCreditCardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a card by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerDeleteCreditCard(id: number, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerDeleteCreditCard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetches billing information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerGetBillingInformation(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerGetBillingInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get credit  cards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerGetCreditCards(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerGetCreditCards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetches invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerGetInvoices(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerGetInvoices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetches receipts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerGetReceipts(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerGetReceipts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle a payment transaction
     * @param {PaymentDetailsDto} paymentDetailsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerHandlePayment(paymentDetailsDto: PaymentDetailsDto, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerHandlePayment(paymentDetailsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stripeSignature 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerHandleStripeWebhook(stripeSignature: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerHandleStripeWebhook(stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a given card as default by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerToggleDefaultCreditCard(id: number, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerToggleDefaultCreditCard(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get profile subscription summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetAccountSubscriptionInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/me/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get profile subscription summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileControllerGetAccountSubscriptionInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileAccountSubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileControllerGetAccountSubscriptionInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.profileControllerGetAccountSubscriptionInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Get profile subscription summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileControllerGetAccountSubscriptionInfo(options?: RawAxiosRequestConfig): AxiosPromise<ProfileAccountSubscriptionResponse> {
            return localVarFp.profileControllerGetAccountSubscriptionInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @summary Get profile subscription summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileControllerGetAccountSubscriptionInfo(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).profileControllerGetAccountSubscriptionInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerCancelSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscriptions/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSubscriptionDto} updateSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerChangeSubscription: async (updateSubscriptionDto: UpdateSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSubscriptionDto' is not null or undefined
            assertParamExists('subscriptionsControllerChangeSubscription', 'updateSubscriptionDto', updateSubscriptionDto)
            const localVarPath = `/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSubscriptionDto} createSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerCreateNewSubscription: async (createSubscriptionDto: CreateSubscriptionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSubscriptionDto' is not null or undefined
            assertParamExists('subscriptionsControllerCreateNewSubscription', 'createSubscriptionDto', createSubscriptionDto)
            const localVarPath = `/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} countryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerGetDefaultPlans: async (countryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryId' is not null or undefined
            assertParamExists('subscriptionsControllerGetDefaultPlans', 'countryId', countryId)
            const localVarPath = `/subscriptions/plans/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (countryId !== undefined) {
                localVarQueryParameter['countryId'] = countryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerGetPlans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscriptions/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerHandleWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscriptions/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerReactivateSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscriptions/reactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerCancelSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerCancelSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerCancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateSubscriptionDto} updateSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerChangeSubscription(updateSubscriptionDto: UpdateSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerChangeSubscription(updateSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerChangeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSubscriptionDto} createSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerCreateNewSubscription(createSubscriptionDto: CreateSubscriptionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerCreateNewSubscription(createSubscriptionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerCreateNewSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} countryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerGetDefaultPlans(countryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerGetDefaultPlans(countryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerGetDefaultPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerGetPlans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerGetPlans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerGetPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerHandleWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerHandleWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerHandleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionsControllerReactivateSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsControllerReactivateSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.subscriptionsControllerReactivateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerCancelSubscription(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscriptionsControllerCancelSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSubscriptionDto} updateSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerChangeSubscription(updateSubscriptionDto: UpdateSubscriptionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscriptionsControllerChangeSubscription(updateSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSubscriptionDto} createSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerCreateNewSubscription(createSubscriptionDto: CreateSubscriptionDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscriptionsControllerCreateNewSubscription(createSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} countryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerGetDefaultPlans(countryId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanDto>> {
            return localVarFp.subscriptionsControllerGetDefaultPlans(countryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerGetPlans(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanDto>> {
            return localVarFp.subscriptionsControllerGetPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerHandleWebhook(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscriptionsControllerHandleWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionsControllerReactivateSubscription(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscriptionsControllerReactivateSubscription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerCancelSubscription(options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerCancelSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateSubscriptionDto} updateSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerChangeSubscription(updateSubscriptionDto: UpdateSubscriptionDto, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerChangeSubscription(updateSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSubscriptionDto} createSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerCreateNewSubscription(createSubscriptionDto: CreateSubscriptionDto, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerCreateNewSubscription(createSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} countryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerGetDefaultPlans(countryId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerGetDefaultPlans(countryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerGetPlans(options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerGetPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerHandleWebhook(options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerHandleWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public subscriptionsControllerReactivateSubscription(options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).subscriptionsControllerReactivateSubscription(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreate: async (createUserDto: CreateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('usersControllerCreate', 'createUserDto', createUserDto)
            const localVarPath = `/v1/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDeleteUser: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerDeleteUser', 'id', id)
            const localVarPath = `/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerEmailSubscribe: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerEmailSubscribe', 'userId', userId)
            const localVarPath = `/v1/users/notifications/email/subscribe/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerEmailUnsubscribe: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('usersControllerEmailUnsubscribe', 'userId', userId)
            const localVarPath = `/v1/users/notifications/email/unsubscribe/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerEmailUnsubscribeWithToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('usersControllerEmailUnsubscribeWithToken', 'token', token)
            const localVarPath = `/v1/users/notifications/email/unsubscribe-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetClientsForClients: async (search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/clients-for-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetClientsForCustomerSuccessUser: async (search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/clients-for-csm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerGetUserById', 'id', id)
            const localVarPath = `/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number
         * @param {number} [take] Limit of rows per page
         * @param {UsersControllerGetUsersByClientIdStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUsersByClientId: async (page?: number, take?: number, status?: UsersControllerGetUsersByClientIdStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerReInvite: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerReInvite', 'id', id)
            const localVarPath = `/v1/users/{id}/re-invite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUser: async (id: number, updateUserDto: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usersControllerUpdateUser', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('usersControllerUpdateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerCreate(createUserDto: CreateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerCreate(createUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerDeleteUser(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerDeleteUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerEmailSubscribe(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerEmailSubscribe(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerEmailSubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerEmailUnsubscribe(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerEmailUnsubscribe(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerEmailUnsubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerEmailUnsubscribeWithToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerEmailUnsubscribeWithToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerEmailUnsubscribeWithToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetClientsForClients(search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetClientsForClients(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetClientsForClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetClientsForCustomerSuccessUser(search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetClientsForCustomerSuccessUser(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetClientsForCustomerSuccessUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetUserById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetUserById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetUserInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetUserInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] Page number
         * @param {number} [take] Limit of rows per page
         * @param {UsersControllerGetUsersByClientIdStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetUsersByClientId(page?: number, take?: number, status?: UsersControllerGetUsersByClientIdStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersControllerGetUsersByClientId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetUsersByClientId(page, take, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetUsersByClientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerReInvite(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerReInvite(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerReInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateUser(id: number, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateUser(id, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerUpdateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCreate(createUserDto: CreateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerCreate(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDeleteUser(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerDeleteUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerEmailSubscribe(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerEmailSubscribe(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerEmailUnsubscribe(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerEmailUnsubscribe(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerEmailUnsubscribeWithToken(token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerEmailUnsubscribeWithToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetClientsForClients(search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientDto>> {
            return localVarFp.usersControllerGetClientsForClients(search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetClientsForCustomerSuccessUser(search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClientDto>> {
            return localVarFp.usersControllerGetClientsForCustomerSuccessUser(search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerGetUserById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserInfo(options?: RawAxiosRequestConfig): AxiosPromise<UserInfoDto> {
            return localVarFp.usersControllerGetUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] Page number
         * @param {number} [take] Limit of rows per page
         * @param {UsersControllerGetUsersByClientIdStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUsersByClientId(page?: number, take?: number, status?: UsersControllerGetUsersByClientIdStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<UsersControllerGetUsersByClientId200Response> {
            return localVarFp.usersControllerGetUsersByClientId(page, take, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerReInvite(id: number, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerReInvite(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUser(id: number, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerUpdateUser(id, updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {CreateUserDto} createUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerCreate(createUserDto: CreateUserDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerCreate(createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerDeleteUser(id: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerDeleteUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerEmailSubscribe(userId: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerEmailSubscribe(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerEmailUnsubscribe(userId: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerEmailUnsubscribe(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerEmailUnsubscribeWithToken(token: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerEmailUnsubscribeWithToken(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetClientsForClients(search?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetClientsForClients(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetClientsForCustomerSuccessUser(search?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetClientsForCustomerSuccessUser(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetUserById(id: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetUserById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetUserInfo(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] Page number
     * @param {number} [take] Limit of rows per page
     * @param {UsersControllerGetUsersByClientIdStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetUsersByClientId(page?: number, take?: number, status?: UsersControllerGetUsersByClientIdStatusEnum, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetUsersByClientId(page, take, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerReInvite(id: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerReInvite(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerUpdateUser(id: number, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUpdateUser(id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UsersControllerGetUsersByClientIdStatusEnum = {
    Verified: 'verified',
    Pending: 'pending',
    Expired: 'expired'
} as const;
export type UsersControllerGetUsersByClientIdStatusEnum = typeof UsersControllerGetUsersByClientIdStatusEnum[keyof typeof UsersControllerGetUsersByClientIdStatusEnum];

